function createResidentsTable(){
    if(getGraph.progress().status != 200){
        return;
    }
    if(datatable){
        datatable.clear();
        datatable.destroy();
    }
    if(mainGraphFilter == ''){
        setMainChartFilter();
    }
    var tableData;
    if(mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'compare-star'){
        tableData = formatTableData(mainDimension.bottom(Infinity));
    }else if(mainGraphFilter == 'deficiencies'){
        tableData = formatIndicatorData(mainDimension.bottom(Infinity));
    }else if(mainGraphFilter == 'surveys'){
        tableData = formatSurveyData(mainDimension.bottom(Infinity), surveyChart);
    }else if(mainGraphFilter == 'qis'){
        tableData = formatSurveyData(mainDimension.bottom(Infinity), qisChart);
    }else if(mainGraphFilter == 'compare-star'){
        tableData = formatFacilityData(mainDimension.bottom(Infinity));
    }
    //residents table
    datatable = $('#resident-table').DataTable({
        "columns": getResidentTableColumns(),
        "paginate": false,
        "lengthChange": false,
        "filter": false,
        "sort": true,
        "info": false,
        "autoWidth": false,
        "deferRender": true,
        "data": tableData,
        "destroy": true,
        "scrollY": ((mainGraphFilter == 'compare-star') ? '733px' : ($('#graphs').height() - 20 - 28)+'px'),
        "scrollX": false,
        "scrollCollapse": true,
        "createdRow": function(row, data, dataIndex){
            if(data.conflict.length != 0){
                $(row).data('conflict', data.conflict);
                $(row).addClass('conflict');
                $(row).css('position', 'relative');
            }
        },
        "initComplete": function(){
            if(isTour && tourStep == 3){
                $.powerTour('run', [1, 4]);
            }
        },
        "drawCallback": function(settings){
            var api = this.api();
            var rows = api.rows().nodes();
            var last = null;
            var patt = new RegExp('F{1}[0-9]{3}');
            var match = false;

            if(mainGraphFilter == 'deficiencies' || mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
                api.column((mainGraphFilter == 'deficiencies' ? 6 : 5)).data().each(function(group, i){
                    if ( last !== group ) {
                        match = patt.test(group);
                        if(!match) group = group.split('-').join(' ');
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="10">'+group+'</td></tr>'
                        );
     
                        last = group;
                    }
                });
            }

            $.each($('.groupResidents'), function(_, value){
                if(!$(this).next().hasClass('groupResidents') && !$(this).prev().hasClass('groupResidents')){
                    $(this).removeClass('groupResidents');
                    return true;
                }
                $(this).css('background', '#fefbe2');
            });
        }
    });


    if(mainGraphFilter == 'census') {
        var lastIDs = [];
        $('#resident-table tr').each(function() {
            currentID = $(this).attr('id');
            if(lastIDs.indexOf(currentID) > -1) {
                $(this).remove();
            } else {
                lastIDs.push(currentID);
            }
        });
    }

    $('.conflict').hover(
        function(){
            if(checkifMobile()){
              return;
            }  
            var data = $(this).data('conflict');
            var defpop;
            if($(this).next('.defPop').length == 0){
                defPop = $('<div class="defPop halfwidth" style="background: #ffe5e5;"><div class="onlyRelWrap"><span class="indicator_desc_close"><i class="icon-cancel-circled" data-icon="i"></i></span><span class="pop-content"><p style="text-align:center;"><img src="/images/ajax-loader-oj-on-white.gif" /></p></span></div></div>').insertAfter($(this));
            }else{
                defPop = $(this).next('.defPop');
            }
            $(defPop).css({'top': 'auto'});
            if(!$(defPop).isOnScreen()){
              $(defPop).css({'left': 'auto', 'right': '-1px'});
            }else if($(defPop).isOnScreen()){
              $(defPop).css({'left': '-1px', 'right': 'auto'});
            }
            $(defPop).find('.pop-content').html('<p>'+data[0].problem+'</p>');
            $(defPop).css('display','block').stop().animate({'opacity':1},300);
        },
        function(){
            var defPop = $(this).next('.defPop');
            $(defPop).stop().animate({'opacity':0},300,function() { $(defPop).css({'left': 'auto', 'right': 'auto'}); $(defPop).css('display','none'); });
        }
    );
}

function getResidentTableColumns(){
    var tableHead = $('#resident-table thead > tr');
    $(tableHead).empty();
    if(mainGraphFilter == 'discharges'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "30%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "27%", "title": "<span>Discharge Date</span>"},
            { "mData": "doctor", "sDefaultContent": " ", "width": "20%", "title": "<span>Physician</span>"},
            { "mData": "financial", "sDefaultContent": " ", "width": "13%", "title": "<span>Payor</span>"},
            { "mData": "LOS", "sDefaultContent": " ", "width": "10%", "class": "los", "title": "<span>LOS</span>"}
        ];
    }else if(mainGraphFilter == 'admissions'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "28%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "28%", "title": "<span>Admission Date</span>"},
            { "mData": "doctor", "sDefaultContent": " ", "width": "25%", "title": "<span>Physician</span>"},
            { "mData": "financial", "sDefaultContent": " ", "width": "17%", "title": "<span>Payor</span>"}
        ];
    }else if(mainGraphFilter == 'paytype'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "30%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "financial", "sDefaultContent": " ", "width": "17%", "title": "<span>Payor</span>"},
            { "mData": "doctor", "sDefaultContent": " ", "width": "23%", "title": "<span>Physician</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "30%", "title": "<span>Admission Date</span>"}
        ];
    }else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "33%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "18%", "title": "<span>Admission</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "18%", "title": "<span>Discharge</span>"},
            { "mData": "financial", "sDefaultContent": " ", "width": "17%", "title": "<span>Payor</span>"},
            { "mData": "LOS", "sDefaultContent": " ", "width": "14%", "class": "los", "title": "<span>LOS</span>"}
        ];
    }else if(mainGraphFilter == 'physician'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "30%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "doctor", "sDefaultContent": " ", "width": "20%", "title": "<span>Physician</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "25%", "title": "<span>Admission Date</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "25%", "title": "<span>Discharge Date</span>"}
        ];
    }else if(mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted'){
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "33%", "title": "<span>Name</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "28%", "title": "<span>Admission Date</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "28%", "title": "<span>Discharge Date</span>"},
            { "mData": "LOS", "sDefaultContent": " ", "width": "10%", "title": "<span>LOS</span>"},
        ];
    }else if(mainGraphFilter == 'origin'){
         residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "30%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "26%", "title": "<span>Admission Date</span>"},
            { "mData": "origin", "sDefaultContent": " ", "width": "44%", "title": "<span>Admit Origin</span>"},
        ];
    }else if(mainGraphFilter == 'census'){
         residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "30%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span>Name</span>"},
            { "mData": "financial", "sDefaultContent": " ", "width": "26%", "title": "<span>Payor</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "44%", "title": "<span>Discharge Date</span>"},
        ];
    }else if(mainGraphFilter == 'deficiencies'){
        residentsTableColumns = [
            { "mData": "id", "sDefaultContent": " ", "width": "16%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>ID</span>"},
            { "mData": "tag", "sDefaultContent": " ", "width": "11%", "title": "<span>Tag</span>"},
            { "mData": "regulation", "sDefaultContent": " ", "width": "22%", "title": "<span>Reg</span>"},
            { "mData": "answer", "sDefaultContent": " ", "width": "10%", "title": "<span>Y/N</span>", "class": "indent"},
            { "mData": "ss", "sDefaultContent": " ", "width": "9%", "title": "<span>SS</span>", "class": "indent"},
            { "mData": "name", "sDefaultContent": "", "width": "32%", "title": "<span>Name</span>"},
            { "mData": "grouper", "sDefaultContent": "", "width": "0%", "title": "<span>Title</span>", "visible": false},
        ];
    }else if(mainGraphFilter == 'surveys'){
        residentsTableColumns = [
            { "mData": "id", "sDefaultContent": " ", "width": "16%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>ID</span>"},
            { "mData": "tag", "sDefaultContent": " ", "width": "11%", "title": "<span>Tag</span>"},
            { "mData": "regulation", "sDefaultContent": " ", "width": "22%", "title": "<span>Reg</span>"},
            { "mData": "answer", "sDefaultContent": " ", "width": "19%", "title": "<span>Answer</span>"},
            { "mData": "name", "sDefaultContent": "", "width": "32%", "title": "<span>Name</span>"},
            { "mData": "grouper", "sDefaultContent": "", "width": "0%", "title": "<span>Title</span>", "visible": false},
        ];
    }else if(mainGraphFilter == 'qis'){
        residentsTableColumns = [
            { "mData": "id", "sDefaultContent": " ", "width": "16%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>ID</span>"},
            { "mData": "tag", "sDefaultContent": " ", "width": "11%", "title": "<span>Tag</span>"},
            { "mData": "regulation", "sDefaultContent": " ", "width": "22%", "title": "<span>Reg</span>"},
            { "mData": "answer", "sDefaultContent": " ", "width": "10%", "title": "<span>Y/N</span>", "class": "indent"},
            { "mData": "name", "sDefaultContent": "", "width": "42%", "title": "<span>Name</span>"},
            { "mData": "grouper", "sDefaultContent": "", "width": "0%", "title": "<span>Title</span>", "visible": false},
        ];
    }else if(mainGraphFilter == 'compare-star'){
        if(nearbyRange == 'federal'){
            residentsTableColumns = [
                { "mData": "state", "sDefaultContent": " ", "width": "36%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>State</span>"},
                { "mData": "health", "sDefaultContent": " ", "width": "16%", "title": "<span>Health</span>", "class": "text-center"},
                { "mData": "qm", "sDefaultContent": " ", "width": "16%", "title": "<span>QM</span>", "class": "text-center"},
                { "mData": "rn", "sDefaultContent": " ", "width": "16%", "title": "<span>RN</span>", "class": "text-center"},
                { "mData": "overall", "sDefaultContent": " ", "width": "16%", "title": "<span>Overall</span>", "class": "text-center"}
            ];
        }else if(nearbyRange == 'state'){
            residentsTableColumns = [
                { "mData": "county", "sDefaultContent": " ", "width": "36%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>County</span>"},
                { "mData": "health", "sDefaultContent": " ", "width": "16%", "title": "<span>Health</span>", "class": "text-center"},
                { "mData": "qm", "sDefaultContent": " ", "width": "16%", "title": "<span>QM</span>", "class": "text-center"},
                { "mData": "rn", "sDefaultContent": " ", "width": "16%", "title": "<span>RN</span>", "class": "text-center"},
                { "mData": "overall", "sDefaultContent": " ", "width": "16%", "title": "<span>Overall</span>", "class": "text-center"}
            ];
        }else{
            residentsTableColumns = [
                { "mData": "facility", "sDefaultContent": " ", "width": "72%", "title": "<a href='#'><i class='icon refreshTable' data-icon='A'></i></a><span style='padding-right: 0;'>Facility</span>"},
                { "mData": "health", "sDefaultContent": " ", "width": "8%", "title": "<span>Health</span>", "class": "text-center"},
                { "mData": "qm", "sDefaultContent": " ", "width": "8%", "title": "<span>QM</span>", "class": "text-center"},
                { "mData": "rn", "sDefaultContent": " ", "width": "8%", "title": "<span>RN</span>", "class": "text-center"},
                { "mData": "overall", "sDefaultContent": " ", "width": "8%", "title": "<span>Overall</span>", "class": "text-center"}
            ];
        }
    }else{
        residentsTableColumns = [
            { "mData": "name", "sDefaultContent": "", "width": "33%", "title": "<span>Name</span>"},
            { "mData": "admit_dt", "sDefaultContent": " ", "width": "33%", "title": "<span>Admission Date</span>"},
            { "mData": "discharge_dt", "sDefaultContent": " ", "width": "33%", "title": "<span>Discharge Date</span>"},
        ];
    }
    for(var i = 0; i < residentsTableColumns.length; i++){
        $(tableHead).append('<th width="'+residentsTableColumns[i]['width']+'">'+residentsTableColumns[i]['title']+'</th>');
}
    return residentsTableColumns;
}

function formatTableData(data){
    var formated = [];
    for(var i = 0; i < data.length; i++){
        if((mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted') && data[i]['readmit'] != 1) continue;
        var set = {};
        set['DT_RowId'] = data[i]['id'];
        if(mainGraphFilter == 'census'){
            set['name'] = fixName(data[i]['name']);
        }else{
            set['name'] = '<a href="#" class="removePerson" data-id="'+data[i]['id']+'"><i class="icon trash" data-icon="T"></i></a>'+fixName(data[i]['name']);
        }
        set['admit_dt'] = padDate((data[i]['admit_dt'].getMonth() + 1))+'-'+padDate(data[i]['admit_dt'].getDate())+'-'+data[i]['admit_dt'].getFullYear().toString().substr(2,2)+' '+((mainGraphFilter != 'lengthofstay' && mainGraphFilter != 'lengthofstaytotal') ? getClockTime(data[i]['admit_dt']) : '');
        if(data[i]['discharge_dt'] != 'In-house'){
            set['discharge_dt'] = padDate((data[i]['discharge_dt'].getMonth() + 1))+'-'+padDate(data[i]['discharge_dt'].getDate())+'-'+data[i]['discharge_dt'].getFullYear().toString().substr(2,2)+' '+((mainGraphFilter != 'lengthofstay' && mainGraphFilter != 'lengthofstaytotal') ? getClockTime(data[i]['discharge_dt']) : '');
        }else{
            set['discharge_dt'] = data[i]['discharge_dt'];
        }

        set['doctor'] = fixName(data[i]['doctor']);
        set['financial'] = data[i]['financial'];
        set['LOS'] = data[i]['LOS'];
        set['origin'] = data[i]['origin'];
        if('conflict' in data[i]){
            set['conflict'] = data[i]['conflict'];
        }else{
            set['conflict'] = [];
        }

        if(('payChange' in data[i]) && data[i]['payChange'] == true){
           set['DT_RowClass'] = 'groupResidents';
        }

        if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
            var PayArray = data[i].financial_change;
            var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
            set['DT_RowId'] = data[i]['id']+'_'+PayArray[sorted[0]];
            set['financial'] = PayArray[sorted[0]];
        }

        formated.push(set);
    }
    return formated;
}

function formatIndicatorData(data){
    var formatted = [];
    data.forEach(function(d){
        if(d.samples) d.samples.forEach(function(sample, i){
            var set = {};
            set['DT_RowClass'] = d.uid.toString();
            if(typeof sample == 'string' || sample instanceof String){
                set['name'] = sample;
                set['DT_RowClass'] = d.uid+' noFacesheet';
            }else{
                set['DT_RowId'] = sample.id;
                set['name'] = fixName(sample.name);
            }
            if(d.no && d.no.indexOf((i + 1).toString()) !== -1){
                set['answer'] = 'N';
            }else if(d.yes && d.yes.indexOf((i + 1).toString()) !== -1){
                set['answer'] = 'Y';
            }
            set['id'] = d.department_abbreviation+'-'+d.ind_dep_count;
            set['tag'] = d.tag;
            set['regulation'] = d.regulation;
            set['ss'] = d.letter;
            set['conflict'] = [];
            var url = '/facility/indicators?'+'td='+d.uid+'&back='+d.last_user;
            set['grouper'] = '<a href="'+url+'" target="_blank"><span><b>'+getMonthName(parseInt(d.month)).toUpperCase()+', '+d.year+'</b></span>'+'<span>'+d.tag+' - '+d.indicator_name+'</span></a>';
            formatted.push(set);
        });
    });
    return formatted;
}

function formatSurveyData(data, chart){
    var formatted = [];
    currentSurveyFilters = chart.filters();
    data.forEach(function(d){
        if(d.samples) d.samples.forEach(function(sample, i){
            if(currentSurveyFilters.length != 0){
                if(currentSurveyFilters.indexOf(d.answers[i+1]) === -1){
                    return;
                }
            }
            var set = {};
            set['DT_RowClass'] = d.answers[i+1]+' '+classDateFormat(d.assignedMonthYear);
            if(typeof sample == 'string' || sample instanceof String){
                set['name'] = sample;
                set['DT_RowClass'] = d.answers[i+1]+' '+classDateFormat(d.assignedMonthYear)+' noFacesheet';
            }else{
                set['DT_RowId'] = sample.id;
                set['name'] = fixName(sample.name);
            }
            if(sample == '[object Object]'){
                return;
            }
            if(d.ind_survey_yes_no == "1" && d.ind_dep_count < 985){
                if(d.answers[i+1] == "5"){
                    set['answer'] = 'YES';
                }else if(d.answers[i+1] == "1"){
                    set['answer'] = 'NO';
                }
            }else if(d.ind_survey_yes_no == "1" && d.ind_dep_count >= 985){
                if(d.answers[i+1] == "2"){
                    set['answer'] = 'N';
                }else if(d.answers[i+1] == "1"){
                    set['answer'] = 'Y';
                }
            }else{
                set['answer'] = d.answers[i+1];
            }
            if(answerValues[set['answer']]){
                set['answer'] = answerValues[set['answer']];
            }

            set['id'] = d.department_abbreviation+'-'+d.ind_dep_count;
            set['tag'] = d.tag;
            set['regulation'] = d.regulation;
            set['conflict'] = [];
            var url = '/assigned-indicators.php?department_uid='+d.ind_dep_uid+'&noDate=1&task_uid='+d.task_uid+'&ind_months='+d.month+'&td_uid='+d.td_uid+'&noDateUserID='+d.last_user;
            set['grouper'] = '<a href="'+url+'" target="_blank"><span><b>'+getMonthName(parseInt(d.month)).toUpperCase()+', '+d.year+'</b></span>'+'<span>'+d.indicator_name+'</span></a>';
            formatted.push(set);
        });
    });
    return formatted;
}

function formatFacilityData(data){
    var formatted = [];
     data.forEach(function(d){
        if(zip !== false){
            if(('isLocal' in d) && d.isLocal){
                return true;
            }
        }
        var set = {};
        set.facility = '<a href="#" class="removeFacility beforeTruncate" data-id="'+d.federal_provider_number+'"><i class="icon trash" data-icon="T"></i></a><span class="truncate">'+toTitleCase(d.facility_name)+'</span>';
        set.state = '<a href="#" class="removeFacility beforeTruncate" data-id="'+d.federal_provider_number+'"><i class="icon trash" data-icon="T"></i></a><span class="truncate">'+(states[d.state] == undefined ? toTitleCase(thisFacilityData.facility_name) : states[d.state])+'</span>';
        set.county = '<a href="#" class="removeFacility beforeTruncate" data-id="'+d.federal_provider_number+'"><i class="icon trash" data-icon="T"></i></a><span class="truncate">'+(states[d.state] == undefined ? toTitleCase(thisFacilityData.facility_name) : toTitleCase(d.county))+'</span>';
        set.location = d.city+', '+d.state;
        set.overall = d.overall_rating;
        set.health = d.health_inspection_rating;
        set.qm = d.qm_rating;
        set.rn = d.rn_staffing_rating;
        set.conflict = [];
        set.DT_RowId = d.federal_provider_number;
        set.DT_RowClass = d.overall_rating.toString()+' facilityFacesheet';
        if(nearbyRange == 'federal' || nearbyRange == 'state'){
            set.overall = parseFloat(set.overall).toFixed(2);
            set.health = parseFloat(set.health).toFixed(2);
            set.qm = parseFloat(set.qm).toFixed(2);
            set.rn = parseFloat(set.rn).toFixed(2);
            if(nearbyRange == 'federal'){
                set.DT_RowId = d.state.replace(/\s/g, '-');
            }else if(nearbyRange == 'state'){
                set.DT_RowId = d.county.replace(/\s/g, '-');
            }
        }
        formatted.push(set);
    });
    return formatted;
}
